import { useQuery } from '@tanstack/react-query'

import { getProductPhotoById } from '@flecto/api/store'
import { type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  storeDomain?: string
  itemId?: ParameterID
  photoId?: ParameterID
}

export function useQueryGetProductPhotoById({
  storeDomain,
  itemId,
  photoId,
}: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetProductPhotoById', storeDomain, itemId, photoId],
    queryFn: async () =>
      await getProductPhotoById(storeDomain ?? '', itemId ?? '', photoId ?? ''),
    refetchOnWindowFocus: false,
    enabled:
      isValidParameterID(itemId) &&
      isValidParameterID(photoId) &&
      Boolean(storeDomain),
  })
}
